<template>
  <div class="create-container">
    <div class="create-pet"></div>
    <div class="pet-info fl-sym-p-2 fl-sym-justify-center fl-sym-items-center">
      <div class="fl-sym-text-xxs fl-sym-text-primary fl-sym-margin-auto">
        CREATE PET PROFILE
      </div>
      <h3
        class="fl-sym-margin-auto fl-sym-text-5xl fl-sym-font-bold fl-sym-mt-12 fl-sym-mb-4 "
      >
        Hi {{ pet.name }}!
      </h3>
      <p
        class="fl-sym-margin-auto fl-sym-text-intermediate fl-sym-mb-5 fl-sym-text-lg fl-sym-pr-3 fl-sym-items-center"
      >
        You can now start using Felcana’s free symptom checker.
      </p>
      <button
        class="fl-sym-w-full fl-sym-relative fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-primary fl-sym-text-sm fl-sym-rounded-full fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-3 fl-sym-mt-10 hover:fl-sym-border-primary"
        @click="toDashboard"
      >
        Continue to Dashboard
        <div
          class="fl-sym-absolute fl-sym-inset-y-0 fl-sym-right-0 fl-sym-flex fl-sym-justify-center fl-sym-items-center fl-sym-pr-4 fl-sym-text-2xl"
        >
          <font-awesome-icon icon="chevron-right" />
        </div>
      </button>
      <div class="fl-sym-text-center">
        <span
          class="fl-sym-mx-auto fl-sym-font-semibold fl-sym-text-primary fl-sym-text-sm fl-sym-cursor-pointer  hover:fl-sym-text-opacity-75"
          @click="$router.go(-1)"
        >
          Back
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  computed: {
    ...mapState({
      pet: (state) => state.pet.pet,
    }),
  },
  mounted() {
    this.dispatchPetToVuex()
  },
  methods: {
    toDashboard() {
      this.$router.push({ name: process.env.VUE_APP_DASHBOARD_INDEX })
    },
    dispatchPetToVuex() {
      this.$store.dispatch("pet/createPetForLoggedInUser", this.pet)
    },
  },
}
</script>

<style>
.create-pet {
  background: url("../../../assets/felcana-pet-small.svg") center padding-box,
    linear-gradient(205deg, #ffa25ce6 0%, #d258fd 71%, #bc00ffe5 100%) 0% 0%
      no-repeat padding-box;
  background-blend-mode: color-dodge;
  width: 100%;
  height: 91.8vh;
  z-index: 30;
}
.pet-info {
  background: white;
  border-radius: 20px 20px 0px 0px;
  border: 300px;
  z-index: 1000;
  position: relative;
  top: -35vh;
  display: inline-block;
  margin: auto;
  width: 100%;
  height: 35vh;
  padding: 10px 20px;
}

.fl-sym-margin-auto {
  margin: auto;
  width: fit-content;
  text-align: center;
}
.create-container {
  height: 91.8vh;
  overflow: hidden;
}
</style>
